export default (elmApp) => {
    
    if(elmApp.ports.focuseOnValue){
        elmApp.ports.focuseOnValue.subscribe(id => {
        	var htmlNode = document.getElementById(id);
        	if (htmlNode) {
        		htmlNode.select();
        	}
        });
    }
}